import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './redux/store';
import './index.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

// Remove StrictMode in development for better HMR experience
// StrictMode causes components to render twice, which can interfere with HMR
const renderApp = () => {
    root.render(
        import.meta.env.DEV ? (
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        ) : (
            <React.StrictMode>
                <Provider store={store}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </Provider>
            </React.StrictMode>
        )
    );
};

renderApp();

// Add HMR acceptance
if (import.meta.hot) {
    import.meta.hot.accept('./App', () => {
        console.log('HMR update for App');
        renderApp();
    });
} 